module.exports = __webpack_public_path__ + "static/media/Croconaw_gaussian2.6a6bfc1d.png";